import { connect } from "react-redux";
import React from "react";
import tesisLogo from '../../public/tesis.png';
import presentationLogo from '../../public/presentation.png';
import tesis from '../../public/Tesis.pdf';
import presentation from '../../public/Presentation.pdf';
import './styles.css'

const download = (file) => {
    // using Java Script method to get PDF file
    fetch(file).then(response => {
        response.blob().then(blob => {
            // Creating new object of PDF file
            const fileURL = window.URL.createObjectURL(blob);
            // Setting various property values
            let alink = document.createElement('a');
            alink.href = fileURL;
            alink.download = file;
            alink.click();
        })
    })
}



const HowItWorks = () => {
    return (
    <div className="HowItWorks">
        <h1>
            How it works?
        </h1>
        <div className="documents">
            <div className="document">
                <img className="document-logo" onClick={()=>download(tesis)} alt={"logo"} src={tesisLogo}/>
                <h2>Documentation</h2>
            </div>
            <div>
                <img className="document-logo" onClick={()=>download(presentation)} alt={"logo"} src={presentationLogo}/>
                <h2>Visualizer</h2>
            </div>
        
        </div>
    </div>
)};

export default connect(
  undefined,
  undefined,
)(HowItWorks)